module.exports = __webpack_public_path__ + "img/plastico_latas.0c3b0152.jpg";